import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from '../../../../../reducers';
import { ShareHolder } from '../../../../models/share-holder.model';
import { selectShareHolders } from '../drill-down.selectors';

@Component({
  selector: 'app-drill-down-share-holders',
  templateUrl: './share-holders.component.html',
  styleUrls: ['./share-holders.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class ShareHoldersComponent implements OnInit {
  shareHolders$: Observable<ShareHolder[]>;

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.shareHolders$ = this.store.pipe(select(selectShareHolders));
  }
}
